import { HappyBox } from "../../../../../doc-comps";
import BasicDemo from "../../../../../components/alert/demo/1-demo-basic";
import BasicDemoCode from "!raw-loader!../../../../../components/alert/demo/1-demo-basic.tsx";
import * as React from 'react';
export default {
  HappyBox,
  BasicDemo,
  BasicDemoCode,
  React
};